import LoginIcon from '@mui/icons-material/Login';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PhoneForwardedIcon from '@mui/icons-material/PhoneForwarded';
import React from 'react';

import { Company } from '_lib/api/apiTypes.shim';
import { IframeContext } from '_lib/callPop/common/CompanyPane/CompanyPane';
import { DialogButton } from '_lib/components/DialogButton/DialogButton';
import { DialogContent } from '_lib/components/DialogContent/DialogContent';
import { Stack } from '_lib/components/Stack/Stack';
import { DialogWrapper } from '_lib/featureComponents/DialogWrapper/DialogWrapper';
import { AsyncDialog, AsyncDialogProps, useAsyncDialog } from '_lib/hooks/useAsyncDialog';

interface FixStPortalDialogProps extends AsyncDialogProps {
  iframeContext: IframeContext;
}

const FixStPortalDialog = (props: FixStPortalDialogProps) => {
  const { onClose, titleText, iframeContext, ...dialogProps } = props;

  return (
    <DialogWrapper onClose={onClose} titleText={'Fix ST Status'} {...dialogProps}>
      <DialogContent>
        <Stack spacing={2} sx={{ padding: 1 }}>
          <DialogButton
            onClick={() => {
              iframeContext.setIframeUrlPath('login');
              onClose({ action: 'CONFIRM' });
            }}
            text={'Redirect to Login'}
            endIcon={<LoginIcon />}
          />
          <DialogButton
            onClick={() => {
              iframeContext.setIframeUrlPath('call handle');
              onClose({ action: 'CONFIRM' });
            }}
            text={'Redirect to Call'}
            endIcon={<PhoneForwardedIcon />}
          />
          <DialogButton
            onClick={async () => {
              window.open(iframeContext.callHandleIframeUrl, '_blank');
              onClose({ action: 'CONFIRM' });
            }}
            text='Open in New Tab'
            endIcon={<OpenInNewIcon />}
          />
        </Stack>
      </DialogContent>
    </DialogWrapper>
  );
};

interface FixStPortalDialog extends AsyncDialog<Company, FixStPortalDialogProps> {}
export const useFixStPortalDialog = (): FixStPortalDialog => useAsyncDialog(FixStPortalDialog);
